const fetchResource = async (url) => {
	const response = await fetch(url);

	if (!response.ok) {
		throw new Error(`Failed to load resource '${url}', status ${response.status}`);
	}

	const contentType = response.headers.get('content-type') || '';

	let data;
	if (contentType.indexOf('application/json') !== -1) {
		data = await response.json();
	} else {
		data = await response.text();
	}

	const headers = {};
	response.headers.forEach((value, key) => {
		headers[key.toLowerCase()] = value;
	});

	return {
		data,
		status: response.status,
		statusText: response.statusText,
		headers,
	};
};

const loading = {};
const loadResource = async (url) => {
	if (url in loading)
		return loading[url];

	const promise = fetchResource(url);
	loading[url] = promise;
	return promise;
};

export default loadResource;